import { HttpService } from '@/shared/services'
import { ICreateLetterConfig } from './dtos/ICreateLetterConfig'
import LetterConfigList from '../models/LetterConfig'
import List from '@/shared/dtos/List'
import IGetLettersConfig from './dtos/IGetLettersConfig'
import LetterConfigDetail from '../models/LetterConfigDetail'
import IUpdateLetterConfig from './dtos/IUpdateLetterConfig'
import LetterAvailables from '../models/LettersAvailables'
import { ILetterApproverDetail } from './dtos/ILetterApproverDetail'

const http = new HttpService()

const buildLetterConfigFormData = (
  letterConfig: ICreateLetterConfig | IUpdateLetterConfig
) => {
  const formData = new FormData()
  const { letterApprovers, ...rest } = letterConfig
  const sanitizedApprovers = (letterApprovers ?? []).map(
    ({ signature, signatureUrl, ...approverRest }: ILetterApproverDetail) => {
      if (signature instanceof File) {
        formData.append('files', signature)
        return {
          ...approverRest,
          signature: null,
        }
      }

      return {
        ...approverRest,
        signature: typeof signature === 'string' ? signature : null,
      }
    }
  )

  const payload = {
    ...rest,
    letterApprovers: sanitizedApprovers,
  }

  formData.append('payload', JSON.stringify(payload))

  return formData
}

export const createLetterConfig = async (letterConfig: ICreateLetterConfig) => {
  const formData = buildLetterConfigFormData(letterConfig)

  const response = await http.post<FormData, string>(
    '/letterConfigs',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return response.data
}

export const getLettersConfig = async (dto?: IGetLettersConfig) => {
  let url = '/letterConfigs'

  if (dto?.companyId) {
    url += `?companyId=${dto.companyId}`
  }

  if (dto?.pagination.search)
    url += `${dto.companyId ? '&' : '?'}search=${dto.pagination.search}`

  if (dto?.isExternal) {
    url += `${dto.companyId || dto.pagination.search ? '&' : '?'}isExternal=${
      dto.isExternal
    }`
  }

  const response = await http.get<List<LetterConfigList[]>>(url)
  return response.data
}

export const getLetterConfigById = async (id: string) => {
  const response = await http.get<LetterConfigDetail>(`/letterConfigs/${id}`)
  console.log(response.data)
  return response.data
}

export const updateLetterConfig = async (letterConfig: IUpdateLetterConfig) => {
  const formData = buildLetterConfigFormData(letterConfig)

  const response = await http.put<FormData, string>(
    `/letterConfigs/${letterConfig.id}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return response.data
}

export const deleteLetterConfigById = async (id: string) => {
  const response = await http.delete<string>(`/letterConfigs/${id}`)
  return response.data
}

export const getAvailableLettersByEmployee = async (employeeId: string) => {
  const response = await http.get<List<LetterAvailables[]>>(
    `/letterConfigs/employee/${employeeId}`
  )

  if (!response.data) return

  return response.data
}

export const getLettersByPayrollId = async (payrollId: string) => {
  const response = await http.get<List<LetterAvailables[]>>(
    `/letterConfigs/payroll/${payrollId}`
  )
  return response.data
}

type GetPreviewLetter = Pick<
  ICreateLetterConfig,
  'header' | 'template' | 'footer' | 'pageProperties'
>

export const getPreviewLetter = async (
  getPreviewInputDto: GetPreviewLetter
) => {
  const response = await http.post<GetPreviewLetter, string>(
    '/letterConfigs/preview',
    getPreviewInputDto,
    {
      responseType: 'blob',
    }
  )

  return response.data
}
